(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain.js', './boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain.js'), require('./boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-removalZone-removalZone-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-removalZone-removalZone-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-removalZone-removalZone-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-removalZone-removalZone-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-removalZone-removalZone-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-removalZone-removalZone-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-removalZone-removalZone-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-removalZone-removalZone-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-removalZone-removalZone-domain'. Its dependency 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain' is loaded prior to 'boislocal-platform-platform-s2-removalZone-removalZone-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-removalZone-removalZone-domain'. Its dependency 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain' is loaded prior to 'boislocal-platform-platform-s2-removalZone-removalZone-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-removalZone-removalZone-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-removalZone-removalZone-domain'.");
    }
    root['boislocal-platform-platform-s2-removalZone-removalZone-domain'] = factory(typeof this['boislocal-platform-platform-s2-removalZone-removalZone-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-removalZone-removalZone-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'], this['boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_woodSpecies_domain, kotlin_org_boislocal_removalZoneCertification_domain, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var $serializer_getInstance = kotlin_org_boislocal_woodSpecies_domain.$_$.a;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var $serializer_getInstance_0 = kotlin_org_boislocal_removalZoneCertification_domain.$_$.a;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var $serializer_init_$Create$ = kotlin_org_boislocal_commons_domain.$_$.a;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var $serializer_getInstance_1 = kotlin_org_boislocal_commons_domain.$_$.f;
  var $serializer_getInstance_2 = kotlin_org_boislocal_commons_domain.$_$.d;
  var $serializer_getInstance_3 = kotlin_org_boislocal_commons_domain.$_$.i;
  var $serializer_getInstance_4 = kotlin_org_boislocal_commons_domain.$_$.h;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var $serializer_getInstance_5 = kotlin_org_boislocal_commons_domain.$_$.g;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var Long = kotlin_kotlin.$_$.ed;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var emptyList = kotlin_kotlin.$_$.b6;
  var equals = kotlin_kotlin.$_$.c9;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var toString = kotlin_kotlin.$_$.le;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var hashCode = kotlin_kotlin.$_$.j9;
  var getNumberHashCode = kotlin_kotlin.$_$.g9;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(RemovalZoneState, 'RemovalZoneState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(RemovalZoneCreateCommandDTO, 'RemovalZoneCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RemovalZoneCreatedEventDTO, 'RemovalZoneCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RemovalZoneDeleteCommandDTO, 'RemovalZoneDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RemovalZoneDeletedEventDTO, 'RemovalZoneDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RemovalZoneImportCommandDTO, 'RemovalZoneImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RemovalZoneImportedEventDTO, 'RemovalZoneImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RemovalZoneUpdateCommandDTO, 'RemovalZoneUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RemovalZoneUpdatedEventDTO, 'RemovalZoneUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RemovalZoneModelDTO, 'RemovalZoneModelDTO', interfaceMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneModel, 'RemovalZoneModel', classMeta, VOID, [RemovalZoneModelDTO, WithS2State, WithS2Id], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(RemovalZoneGetQueryDTO, 'RemovalZoneGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(RemovalZoneGetResponseDTO, 'RemovalZoneGetResponseDTO', interfaceMeta);
  setMetadataFor(RemovalZonePageQueryFiltersDTO, 'RemovalZonePageQueryFiltersDTO', interfaceMeta);
  setMetadataFor(RemovalZonePageQueryDTO, 'RemovalZonePageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(RemovalZonePageResponseDTO, 'RemovalZonePageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.x2o_1.f2();
  }
  function RemovalZoneState$Companion$_anonymous__wzr2c6() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.removalZone.domain.automate.RemovalZoneState', values());
  }
  var RemovalZoneState_Exists_instance;
  var RemovalZoneState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x2o_1 = lazy(tmp_0, RemovalZoneState$Companion$_anonymous__wzr2c6);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    RemovalZoneState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [RemovalZoneState_Exists_getInstance(), RemovalZoneState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return RemovalZoneState_Exists_getInstance();
      case 'Deleted':
        return RemovalZoneState_Deleted_getInstance();
      default:
        RemovalZoneState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RemovalZoneState_entriesInitialized;
  function RemovalZoneState_initEntries() {
    if (RemovalZoneState_entriesInitialized)
      return Unit_instance;
    RemovalZoneState_entriesInitialized = true;
    RemovalZoneState_Exists_instance = new RemovalZoneState('Exists', 0, 0);
    RemovalZoneState_Deleted_instance = new RemovalZoneState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function RemovalZoneState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.a2p_1 = position;
  }
  protoOf(RemovalZoneState).y2c = function (_set____db54di) {
    this.a2p_1 = _set____db54di;
  };
  protoOf(RemovalZoneState).jr = function () {
    return this.a2p_1;
  };
  function RemovalZoneState_Exists_getInstance() {
    RemovalZoneState_initEntries();
    return RemovalZoneState_Exists_instance;
  }
  function RemovalZoneState_Deleted_getInstance() {
    RemovalZoneState_initEntries();
    return RemovalZoneState_Deleted_instance;
  }
  function RemovalZoneCreateCommandDTO() {
  }
  function RemovalZoneCreatedEventDTO() {
  }
  function RemovalZoneDeleteCommandDTO() {
  }
  function RemovalZoneDeletedEventDTO() {
  }
  function RemovalZoneImportCommandDTO() {
  }
  function RemovalZoneImportedEventDTO() {
  }
  function RemovalZoneUpdateCommandDTO() {
  }
  function RemovalZoneUpdatedEventDTO() {
  }
  function RemovalZoneModelDTO() {
  }
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j2p_1 = [null, Companion_getInstance().x14(), null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance()), new ArrayListSerializer($serializer_getInstance_0()), null, null, null, $serializer_init_$Create$(StringSerializer_getInstance())];
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.removalZone.domain.model.RemovalZoneModel', this, 16);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('massif', false);
    tmp0_serialDesc.ht('department', false);
    tmp0_serialDesc.ht('commune', true);
    tmp0_serialDesc.ht('city', true);
    tmp0_serialDesc.ht('geo', false);
    tmp0_serialDesc.ht('geoJson', false);
    tmp0_serialDesc.ht('radius', false);
    tmp0_serialDesc.ht('woodSpecies', false);
    tmp0_serialDesc.ht('certifications', true);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    tmp0_serialDesc.ht('organization', false);
    this.k2p_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.k2p_1;
  };
  protoOf($serializer).wt = function () {
    var tmp0_cached = Companion_getInstance_0().j2p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_1()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_4()), get_nullable(DoubleSerializer_getInstance()), tmp0_cached[10], tmp0_cached[11], get_nullable($serializer_getInstance_5()), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), tmp0_cached[15]];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.k2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = new Long(0, 0);
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_input = decoder.ul(tmp0_desc);
    var tmp21_cached = Companion_getInstance_0().j2p_1;
    if (tmp20_input.km()) {
      tmp4_local0 = tmp20_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.gm(tmp0_desc, 1, tmp21_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.im(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.im(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.im(tmp0_desc, 7, $serializer_getInstance_3(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.im(tmp0_desc, 8, $serializer_getInstance_4(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.im(tmp0_desc, 9, DoubleSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.gm(tmp0_desc, 10, tmp21_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.gm(tmp0_desc, 11, tmp21_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.im(tmp0_desc, 12, $serializer_getInstance_5(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.am(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.im(tmp0_desc, 14, LongSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.gm(tmp0_desc, 15, tmp21_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.gm(tmp0_desc, 1, tmp21_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.im(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.im(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.im(tmp0_desc, 7, $serializer_getInstance_3(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.im(tmp0_desc, 8, $serializer_getInstance_4(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.im(tmp0_desc, 9, DoubleSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.gm(tmp0_desc, 10, tmp21_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.gm(tmp0_desc, 11, tmp21_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.im(tmp0_desc, 12, $serializer_getInstance_5(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.am(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.im(tmp0_desc, 14, LongSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.gm(tmp0_desc, 15, tmp21_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.vl(tmp0_desc);
    return RemovalZoneModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer).l2p = function (encoder, value) {
    var tmp0_desc = this.k2p_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_0().j2p_1;
    tmp1_output.jn(tmp0_desc, 0, value.m2p_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.n2p_1);
    tmp1_output.jn(tmp0_desc, 2, value.o2p_1);
    tmp1_output.nn(tmp0_desc, 3, StringSerializer_getInstance(), value.p2p_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_1(), value.q2p_1);
    if (tmp1_output.rn(tmp0_desc, 5) ? true : !(value.r2p_1 == null)) {
      tmp1_output.nn(tmp0_desc, 5, StringSerializer_getInstance(), value.r2p_1);
    }
    if (tmp1_output.rn(tmp0_desc, 6) ? true : !(value.s2p_1 == null)) {
      tmp1_output.nn(tmp0_desc, 6, $serializer_getInstance_2(), value.s2p_1);
    }
    tmp1_output.nn(tmp0_desc, 7, $serializer_getInstance_3(), value.t2p_1);
    tmp1_output.nn(tmp0_desc, 8, $serializer_getInstance_4(), value.u2p_1);
    tmp1_output.nn(tmp0_desc, 9, DoubleSerializer_getInstance(), value.v2p_1);
    tmp1_output.ln(tmp0_desc, 10, tmp2_cached[10], value.w2p_1);
    if (tmp1_output.rn(tmp0_desc, 11) ? true : !equals(value.x2p_1, emptyList())) {
      tmp1_output.ln(tmp0_desc, 11, tmp2_cached[11], value.x2p_1);
    }
    tmp1_output.nn(tmp0_desc, 12, $serializer_getInstance_5(), value.y2p_1);
    tmp1_output.fn(tmp0_desc, 13, value.z2p_1);
    tmp1_output.nn(tmp0_desc, 14, LongSerializer_getInstance(), value.a2q_1);
    tmp1_output.ln(tmp0_desc, 15, tmp2_cached[15], value.b2q_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.l2p(encoder, value instanceof RemovalZoneModel ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_6() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function RemovalZoneModel_init_$Init$(seen1, id, status, name, massif, department, commune, city, geo, geoJson, radius, woodSpecies, certifications, img, creationDate, updatedDate, organization, serializationConstructorMarker, $this) {
    if (!(63391 === (63391 & seen1))) {
      throwMissingFieldException(seen1, 63391, $serializer_getInstance_6().k2p_1);
    }
    $this.m2p_1 = id;
    $this.n2p_1 = status;
    $this.o2p_1 = name;
    $this.p2p_1 = massif;
    $this.q2p_1 = department;
    if (0 === (seen1 & 32))
      $this.r2p_1 = null;
    else
      $this.r2p_1 = commune;
    if (0 === (seen1 & 64))
      $this.s2p_1 = null;
    else
      $this.s2p_1 = city;
    $this.t2p_1 = geo;
    $this.u2p_1 = geoJson;
    $this.v2p_1 = radius;
    $this.w2p_1 = woodSpecies;
    if (0 === (seen1 & 2048))
      $this.x2p_1 = emptyList();
    else
      $this.x2p_1 = certifications;
    $this.y2p_1 = img;
    $this.z2p_1 = creationDate;
    $this.a2q_1 = updatedDate;
    $this.b2q_1 = organization;
    return $this;
  }
  function RemovalZoneModel_init_$Create$(seen1, id, status, name, massif, department, commune, city, geo, geoJson, radius, woodSpecies, certifications, img, creationDate, updatedDate, organization, serializationConstructorMarker) {
    return RemovalZoneModel_init_$Init$(seen1, id, status, name, massif, department, commune, city, geo, geoJson, radius, woodSpecies, certifications, img, creationDate, updatedDate, organization, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneModel)));
  }
  function RemovalZoneModel() {
  }
  protoOf(RemovalZoneModel).k1y = function () {
    return this.m2p_1;
  };
  protoOf(RemovalZoneModel).y2f = function () {
    return this.n2p_1;
  };
  protoOf(RemovalZoneModel).h9 = function () {
    return this.o2p_1;
  };
  protoOf(RemovalZoneModel).d2p = function () {
    return this.p2p_1;
  };
  protoOf(RemovalZoneModel).e2p = function () {
    return this.q2p_1;
  };
  protoOf(RemovalZoneModel).f2p = function () {
    return this.r2p_1;
  };
  protoOf(RemovalZoneModel).j28 = function () {
    return this.s2p_1;
  };
  protoOf(RemovalZoneModel).b2p = function () {
    return this.t2p_1;
  };
  protoOf(RemovalZoneModel).i2p = function () {
    return this.u2p_1;
  };
  protoOf(RemovalZoneModel).w29 = function () {
    return this.v2p_1;
  };
  protoOf(RemovalZoneModel).g2p = function () {
    return this.w2p_1;
  };
  protoOf(RemovalZoneModel).h2p = function () {
    return this.x2p_1;
  };
  protoOf(RemovalZoneModel).d2d = function () {
    return this.y2p_1;
  };
  protoOf(RemovalZoneModel).v2h = function () {
    return this.z2p_1;
  };
  protoOf(RemovalZoneModel).w2h = function () {
    return this.a2q_1;
  };
  protoOf(RemovalZoneModel).c2p = function () {
    return this.b2q_1;
  };
  protoOf(RemovalZoneModel).s2State = function () {
    return this.n2p_1;
  };
  protoOf(RemovalZoneModel).s2Id = function () {
    return this.m2p_1;
  };
  protoOf(RemovalZoneModel).toString = function () {
    return 'RemovalZoneModel(id=' + this.m2p_1 + ', status=' + this.n2p_1 + ', name=' + this.o2p_1 + ', massif=' + this.p2p_1 + ', department=' + this.q2p_1 + ', commune=' + this.r2p_1 + ', city=' + this.s2p_1 + ', geo=' + this.t2p_1 + ', geoJson=' + this.u2p_1 + ', radius=' + this.v2p_1 + ', woodSpecies=' + this.w2p_1 + ', certifications=' + this.x2p_1 + ', img=' + this.y2p_1 + ', creationDate=' + this.z2p_1.toString() + ', updatedDate=' + toString(this.a2q_1) + ', organization=' + this.b2q_1 + ')';
  };
  protoOf(RemovalZoneModel).hashCode = function () {
    var result = getStringHashCode(this.m2p_1);
    result = imul(result, 31) + this.n2p_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.o2p_1) | 0;
    result = imul(result, 31) + (this.p2p_1 == null ? 0 : getStringHashCode(this.p2p_1)) | 0;
    result = imul(result, 31) + (this.q2p_1 == null ? 0 : this.q2p_1.hashCode()) | 0;
    result = imul(result, 31) + (this.r2p_1 == null ? 0 : getStringHashCode(this.r2p_1)) | 0;
    result = imul(result, 31) + (this.s2p_1 == null ? 0 : this.s2p_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t2p_1 == null ? 0 : this.t2p_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u2p_1 == null ? 0 : hashCode(this.u2p_1)) | 0;
    result = imul(result, 31) + (this.v2p_1 == null ? 0 : getNumberHashCode(this.v2p_1)) | 0;
    result = imul(result, 31) + hashCode(this.w2p_1) | 0;
    result = imul(result, 31) + hashCode(this.x2p_1) | 0;
    result = imul(result, 31) + (this.y2p_1 == null ? 0 : this.y2p_1.hashCode()) | 0;
    result = imul(result, 31) + this.z2p_1.hashCode() | 0;
    result = imul(result, 31) + (this.a2q_1 == null ? 0 : this.a2q_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.b2q_1) | 0;
    return result;
  };
  protoOf(RemovalZoneModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneModel))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneModel ? other : THROW_CCE();
    if (!(this.m2p_1 === tmp0_other_with_cast.m2p_1))
      return false;
    if (!this.n2p_1.equals(tmp0_other_with_cast.n2p_1))
      return false;
    if (!(this.o2p_1 === tmp0_other_with_cast.o2p_1))
      return false;
    if (!(this.p2p_1 == tmp0_other_with_cast.p2p_1))
      return false;
    if (!equals(this.q2p_1, tmp0_other_with_cast.q2p_1))
      return false;
    if (!(this.r2p_1 == tmp0_other_with_cast.r2p_1))
      return false;
    if (!equals(this.s2p_1, tmp0_other_with_cast.s2p_1))
      return false;
    if (!equals(this.t2p_1, tmp0_other_with_cast.t2p_1))
      return false;
    if (!equals(this.u2p_1, tmp0_other_with_cast.u2p_1))
      return false;
    if (!equals(this.v2p_1, tmp0_other_with_cast.v2p_1))
      return false;
    if (!equals(this.w2p_1, tmp0_other_with_cast.w2p_1))
      return false;
    if (!equals(this.x2p_1, tmp0_other_with_cast.x2p_1))
      return false;
    if (!equals(this.y2p_1, tmp0_other_with_cast.y2p_1))
      return false;
    if (!this.z2p_1.equals(tmp0_other_with_cast.z2p_1))
      return false;
    if (!equals(this.a2q_1, tmp0_other_with_cast.a2q_1))
      return false;
    if (!equals(this.b2q_1, tmp0_other_with_cast.b2q_1))
      return false;
    return true;
  };
  function RemovalZoneGetQueryDTO() {
  }
  function RemovalZoneGetResponseDTO() {
  }
  function RemovalZonePageQueryFiltersDTO() {
  }
  function RemovalZonePageQueryDTO() {
  }
  function RemovalZonePageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(RemovalZoneState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(RemovalZoneState), 'name', protoOf(RemovalZoneState).h9);
  defineProp(protoOf(RemovalZoneState), 'ordinal', protoOf(RemovalZoneState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RemovalZoneModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(RemovalZoneModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RemovalZoneModel), 'massif', function () {
    return this.d2p();
  });
  defineProp(protoOf(RemovalZoneModel), 'department', function () {
    return this.e2p();
  });
  defineProp(protoOf(RemovalZoneModel), 'commune', function () {
    return this.f2p();
  });
  defineProp(protoOf(RemovalZoneModel), 'city', function () {
    return this.j28();
  });
  defineProp(protoOf(RemovalZoneModel), 'geo', function () {
    return this.b2p();
  });
  defineProp(protoOf(RemovalZoneModel), 'geoJson', function () {
    return this.i2p();
  });
  defineProp(protoOf(RemovalZoneModel), 'radius', function () {
    return this.w29();
  });
  defineProp(protoOf(RemovalZoneModel), 'woodSpecies', function () {
    return this.g2p();
  });
  defineProp(protoOf(RemovalZoneModel), 'certifications', function () {
    return this.h2p();
  });
  defineProp(protoOf(RemovalZoneModel), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(RemovalZoneModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(RemovalZoneModel), 'updatedDate', function () {
    return this.w2h();
  });
  defineProp(protoOf(RemovalZoneModel), 'organization', function () {
    return this.c2p();
  });
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$automate = $org$boislocal$platform$s2$removalZone$domain.automate || ($org$boislocal$platform$s2$removalZone$domain.automate = {});
    $org$boislocal$platform$s2$removalZone$domain$automate.RemovalZoneState = RemovalZoneState;
    $org$boislocal$platform$s2$removalZone$domain$automate.RemovalZoneState.values = values;
    $org$boislocal$platform$s2$removalZone$domain$automate.RemovalZoneState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$removalZone$domain$automate.RemovalZoneState, 'Exists', RemovalZoneState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$removalZone$domain$automate.RemovalZoneState, 'Deleted', RemovalZoneState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$removalZone$domain$automate.RemovalZoneState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$command = $org$boislocal$platform$s2$removalZone$domain.command || ($org$boislocal$platform$s2$removalZone$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$command = $org$boislocal$platform$s2$removalZone$domain.command || ($org$boislocal$platform$s2$removalZone$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$command = $org$boislocal$platform$s2$removalZone$domain.command || ($org$boislocal$platform$s2$removalZone$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$command = $org$boislocal$platform$s2$removalZone$domain.command || ($org$boislocal$platform$s2$removalZone$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$model = $org$boislocal$platform$s2$removalZone$domain.model || ($org$boislocal$platform$s2$removalZone$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$query = $org$boislocal$platform$s2$removalZone$domain.query || ($org$boislocal$platform$s2$removalZone$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZone = $org$boislocal$platform$s2.removalZone || ($org$boislocal$platform$s2.removalZone = {});
    var $org$boislocal$platform$s2$removalZone$domain = $org$boislocal$platform$s2$removalZone.domain || ($org$boislocal$platform$s2$removalZone.domain = {});
    var $org$boislocal$platform$s2$removalZone$domain$query = $org$boislocal$platform$s2$removalZone$domain.query || ($org$boislocal$platform$s2$removalZone$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance_6;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-removalZone-removalZone-domain.js.map
